import './ToggleButtonGroupUiObject.scss';
import React, { useEffect, useState } from 'react';
import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useLanguage } from '../common/GeneralUtils';
import { OrderPageState } from './types/OrderPageState';

type ToggleButtonGroupUiObjectProps = {
  uiObject: any;
  orderState: OrderPageState;
  setOrderDetailValue: (name: string, value: string) => void;
  setCustomOrderDetailValue: (name: string, value: string) => void;
  setOrderCustomDetails: (details: any) => void;
};
const ToggleButtonGroupUiObject = ({
  uiObject,
  orderState,
  setOrderDetailValue,
  setCustomOrderDetailValue,
  setOrderCustomDetails,
}: ToggleButtonGroupUiObjectProps) => {
  const [searchParams] = useSearchParams();
  const selectedOption = searchParams.get('selectedoption') || undefined;

  const language = useLanguage();
  const objectName = uiObject.name;
  const uiObjectValueFromState = orderState.details.custom_details[objectName];
  const defaultValue =
    uiObject.data_type === 'custom'
      ? uiObjectValueFromState || uiObject.options[0].value
      : `${orderState.details[uiObject.data_type as keyof typeof orderState.details]}`;
  // ^ todo remove when there are more types

  useEffect(() => {
    if (uiObject.data_type === 'custom') {
      // there is some race ocndition in state setting
      // todo it better. mb initiation has to be already initiated with all relevant stuff
      setTimeout(() => setCustomOrderDetailValue(uiObject.name, defaultValue), 500);
    }
  }, []);

  const [value, setValue] = useState(defaultValue);

  const onValueChange = (e: any, val: any) => {
    if (val != null) {
      // for deselection
      setValue(val);
      if (uiObject.data_type === 'custom') {
        const data = {
          [uiObject.name]: val,
        };

        setOrderCustomDetails(data);
      } else {
        const numVal = Number(val);
        setOrderDetailValue(uiObject.data_type, Number.isFinite(numVal) ? numVal : val);
      }
    }
  };
  // hack because some race wit state setting erases it condition
  useEffect(() => {
    if (selectedOption) {
      setTimeout(() => {
        onValueChange(null, selectedOption);
      }, 500);
    }
  }, [selectedOption]);
  // we done want to see selection in ui when we have preselected
  if (selectedOption) {
    return null;
  }
  return (
    <div className="toggle-button-ui-object">
      <Typography variant="h6">{uiObject.label[language]}</Typography>

      <div className="toggle-button-container">
        <ToggleButtonGroup value={value} exclusive onChange={onValueChange}>
          {uiObject.options.map((option: any) => {
            return (
              <ToggleButton key={option.value} className="toggle-button" value={`${option.value}`}>
                {option.label[language]}
              </ToggleButton>
            );
          })}
        </ToggleButtonGroup>
      </div>
    </div>
  );
};

export default ToggleButtonGroupUiObject;
